export default {
  /**
   * @desc 防抖函数
   * @param {Function} fn 执行函数
   * @param {date} t 执行频次时间
   */
  debounce(fn, t = 1000) {
    let timeout = null
    let debounced = function () {
      if (timeout) clearTimeout(timeout)
      timeout = setTimeout(function () {
        fn()
      }, t)
    }
    return debounced
  },
  downLoad(url, fileName = Date.now()) {
    const alink = document.createElement('a')
    alink.style.display = 'none'
    alink.href = typeof url == 'string' ? url : window.URL.createObjectURL(blob)
    alink.download = `${fileName}`
    document.body.appendChild(alink)
    alink.click()
    URL.revokeObjectURL(alink.href)
    document.body.removeChild(alink)
  },
  /**
   * @param {string} txt
   * @returns string
   */
  fromatText(txt) {
    let div = document.createElement('div')
    div.innerHTML = txt
    return div.textContent
  },
  // meta标签文字超出处理
  subString(str = '', num = 0) {
    return str && str.length > num
      ? str.substr(0, num) + '... '
      : `${str || ''} `
  },
  // 时间戳转换日期格式
  timestampToTime(timestamp) {
    var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '-'
    const M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '-'
    const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ' '
    const h =
      date.getHours() < 10 ? '0' + date.getHours() : date.getHours() + ':'
    const m =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    // s = date.getSeconds();
    return Y + M + D + h + m
    // return Y+M+D+h+m+s;
  },
}
